import React from 'react';
import type { OnboardingSummary } from '../../../types/onboarding';
import {
  SectionOne,
  SectionTwo,
  SectionThree,
  SectionFour,
  SectionFive,
  SectionSix,
  SectionSeven,
  SectionEight,
} from './objectives';

interface ObjectiveSectionProps {
  section: OnboardingSummary;
}

const ObjectiveSection = (props: ObjectiveSectionProps) => {
  const { section } = props;

  const primaryGoal = section.questions.find(
    question => question.code === 'primary_goal'
  )?.user_response as string;

  return (
    <div>
      {primaryGoal === 'Raising capital for my start-up' && (
        <SectionOne section={section} />
      )}

      {primaryGoal ===
        'Finding investment opportunities (as a VC, angel, etc.)' && (
        <SectionTwo section={section} />
      )}

      {primaryGoal === 'Generating qualified sales leads for my business' && (
        <SectionThree section={section} />
      )}

      {primaryGoal === 'Finding a mentor or career advisor' && (
        <SectionFour section={section} />
      )}

      {primaryGoal === 'Offering mentorship to others' && (
        <SectionFive section={section} />
      )}

      {primaryGoal === 'Exploring strategic partnerships or collaborations' && (
        <SectionSix section={section} />
      )}

      {primaryGoal === 'Recruiting for a key role' && (
        <SectionSeven section={section} />
      )}

      {primaryGoal === 'General learning and professional development' && (
        <SectionEight section={section} />
      )}
    </div>
  );
};

export default ObjectiveSection;
